import React, {useState} from "react";
import {makeStyles} from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";
import Slide from '@material-ui/core/Slide';

const useStyles = makeStyles((theme) => ({
  popup1: {
    bottom: theme.spacing(5),
    backgroundColor: 'white',
    position: 'absolute',
    borderRadius: '0.8em',
    padding: '10px 30px',
  },
  popup2: {
    left: theme.spacing(18),
    bottom: theme.spacing(12),
    backgroundColor: 'white',
    position: 'absolute',
    borderRadius: '0.8em',
    padding: '10px 30px',
  }
}));

export default function PopUp(props) {

  const [show, setShow] = useState(true);

  const classes = useStyles();

  setTimeout(()=>setShow(false),2500);

  return (
    <Slide in={show} direction='up' timeout={1000}>
      <div className={props.type === 'login'? classes.popup1: classes.popup2}>
        <Typography variant="body2" color="primary" align="center">
          Access token copied to clipboard
        </Typography>
      </div>
    </Slide>
  );
}
